import React from 'react';

function AddTopIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			fill='none'
			viewBox='0 0 16 16'
		>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='M11.667 14.333c.729-.132 1.266-.366 1.69-.78.976-.953.976-2.486.976-5.553 0-3.067 0-4.6-.976-5.553-.424-.414-.961-.648-1.69-.78M4.333 1.667c-.729.132-1.266.366-1.69.78C1.667 3.4 1.667 4.933 1.667 8c0 3.067 0 4.6.976 5.553.424.414.961.648 1.69.78M9.333 14.33c-.39.003-.859.003-1.316.003-.457 0-.967 0-1.358-.003M9.333 1.67c-.39-.003-.859-.003-1.316-.003-.457 0-.967 0-1.358.003M8 14.333v-1M8 2.667v-1M10 8L8 6M6 8l2-2m0 4V6'
			></path>
		</svg>
	);
}

export default AddTopIcon;
